import React from "react";
import {Box, Typography} from "@mui/material";
import {a} from "./authStyles";
import {PASSWORD_RULES} from "./PasswordChecklist";

// By how many of the rules are met (0-5): soft pastel bar colour, and a deeper tone of it for the readable label
const ROSE = {bar: "#F4A9B8", text: "#C2576F"};
const PEACH = {bar: "#F7C6A3", text: "#BF7440"};
const SAND = {bar: "#F3E0A0", text: "#9A7B1E"};
const SAGE = {bar: "#BFE3B4", text: "#4F8A43"};
const MINT = {bar: "#9ED9C0", text: "#2F8A66"};
const LEVELS = [
  {label: "Too weak", ...ROSE},
  {label: "Too weak", ...ROSE},
  {label: "Weak", ...PEACH},
  {label: "Fair", ...SAND},
  {label: "Good", ...SAGE},
  {label: "Strong", ...MINT},
];

// Password health as a plain thin progress bar, filled as the rules are met. Under it, what is still
// missing (or that everything is met). showErrors: after a failed submit the missing part turns red.
export const PasswordStrengthBar = ({password, showErrors}) => {
  const missing = PASSWORD_RULES.filter(rule => !rule.test(password));
  const met = PASSWORD_RULES.length - missing.length;
  const level = LEVELS[met];

  return (
    <Box sx={{px: 0.75, pb: 1.5}}>
      {/* one thin track, filled in proportion to the rules met */}
      <Box sx={{height: 3, borderRadius: "980px", bgcolor: "rgba(20,21,26,0.08)", overflow: "hidden"}}>
        <Box sx={{
          width: `${(met / PASSWORD_RULES.length) * 100}%`, height: "100%", borderRadius: "980px",
          bgcolor: level.bar, transition: "width .25s ease, background-color .25s ease",
        }}/>
      </Box>
      <Typography sx={{
        mt: 0.75, fontSize: 12.5, lineHeight: 1.4,
        color: showErrors && missing.length ? ROSE.text : a.muted,
      }}>
        {missing.length
          ? `Still needed: ${missing.map(rule => rule.label.toLowerCase()).join(", ")}`
          : "All requirements met"}
      </Typography>
    </Box>
  );
};
